import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home"; // Landing page
import Login from "./pages/Login"; // Admin login
import Dashboard from "./pages/Dashboard";
import DashboardHome from "./pages/DashboardHome"; // 🔥 TAMBAH INI
import Categories from "./pages/Categories";
import Products from "./pages/Products";
import CompanyProfile from "./pages/CompanyProfile";
import ProtectedRoute from "./components/ProtectedRoutes";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* =====================
            🌐 LANDING PAGE
        ===================== */}
        <Route path="/" element={<Home />} />

        {/* =====================
            🔐 ADMIN LOGIN
        ===================== */}
        <Route path="/manage-login" element={<Login />} />

        {/* =====================
            🛡️ PROTECTED DASHBOARD
        ===================== */}
        <Route element={<ProtectedRoute />}>
          <Route path="/dashboard" element={<Dashboard />}>

            {/* 🔥 DASHBOARD HOME */}
            <Route index element={<DashboardHome />} />

            {/* 📁 MASTER DATA */}
            <Route path="categories" element={<Categories />} />
            <Route path="products" element={<Products />} />

            {/* 🏢 COMPANY */}
            <Route path="company-profile" element={<CompanyProfile />} />
          </Route>
        </Route>

        {/* =====================
            ❌ 404
        ===================== */}
        <Route path="*" element={<p>Page Not Found</p>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
